export default __webpack_public_path__ + "static/media/telefono.32b742da.png";